/**
 * Whether a tray-to-canvas placement pointer drag (photo, ClikArt or template) is in progress.
 * A keyboard carry does not count: it never clears the selection.
 *
 * Starting a drag clears the canvas selection (`beginPointerDrag`), which is not the user
 * deselecting. Anything that reacts to "the selection emptied", like hiding the Left Panel when a
 * ClikArt is deselected, reads this to tell the two apart (WMPCM-13378). Set from the placement
 * session's phase, so it covers the whole drag, from the press to the drop or cancel.
 */
let active = false

export function setPlacementDragActive(next: boolean): void {
  active = next
}

export function isPlacementDragActive(): boolean {
  return active
}
